import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppExeDLInfo } from '../../_objects/distributes';
import { HttpService } from '../http.service';
import { DistributionManagementContractService } from '../interfaces/distribution-management-contract.service';
import { UtilsService } from '../_utils.service';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class DistributionManagementOnlineService extends HttpService implements DistributionManagementContractService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router,
    private electronService: ElectronService,
    private utils: UtilsService) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  // 【DI01】EXEファイル取得
  // GET /api/distribution/exe
  getAppExe(version: string): Observable<AppExeDLInfo> {
    const endpoint = super.getEndpoint('distribution', 'exe');

    let httpParams = new HttpParams();
    httpParams = httpParams.set('version', String(version));

      return this.http.get(endpoint, {
        withCredentials: super.getWithCredentialsOption(), params: httpParams
      }).pipe(map(response => response as AppExeDLInfo));
  }
}
